import React from "react";
import { Typography, Paper } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import TopOfAddStepTables from "../../CellStepManagement/components/TopOfAddStepTables";
import External from "../../CellStepManagement/components/External";
import EmbeddedTable from "../../CellStepManagement/components/EmbeddedTable";
import PaginationBlock from "./PaginationBlock";
import Divider from "@mui/material/Divider";

const StepTypeEmbedded = ({
  newItem,
  toggleItem,
  url,
  param,
  name,
  onChange,
  onParamChange,
  onNameChange,
  handleClick,
  id,
  studyId,
  stepType,
  data,
  loading,
  rowsPerPage,
  currentPage,
  onPageChange,
  onRowsPerPageChange,
  onSearch,
  setHasSearched,
  hasSearched,
  resetStateToLoading,
  onSelectItem,
  resultCount,
  onDone,
}) => {
  return (
    <div style={{ width: "100%" }}>
      <div style={{ padding: "4px 0 12px", width: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 16,
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              minWidth: 220,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography variant="subtitle1" style={{ lineHeight: 1.2 }}>
              Add a new embedded step
            </Typography>

            <Typography
              variant="caption"
              color="textSecondary"
              style={{
                marginTop: 2,
                lineHeight: 1.2,
              }}
            >
              An embedded step shows a webpage created by a third party
              (including Lumen&apos;s eye-tracking script), not hosted on a
              Lumen domain,
              <br />
              but shown as part of a Lumen study
            </Typography>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 8,
              marginLeft: "auto",
              minWidth: 0,
              flex: 1,
              justifyContent: "flex-end",
            }}
          >
            <div style={{ width: "100%", maxWidth: 420 }}>
              <TopOfAddStepTables
                button
                buttonText="Embedded step"
                buttonClick={toggleItem}
                textFieldLabel="Search embedded steps"
                textFieldChange={(term) => {
                  onSearch(term);
                  if (term.length > 2) {
                    setHasSearched(true);
                    resetStateToLoading();
                    onSelectItem(
                      stepType,
                      studyId,
                      term,
                      rowsPerPage,
                      currentPage
                    );
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <Paper
        elevation={0}
        square
        style={{
          padding: 0,
          borderRadius: 0,
          marginBottom: 24,
          background: "transparent",
        }}
      >
        {!newItem ? (
          <>
            <Divider
              sx={{
                borderColor: "rgba(0,0,0,0.08)",
              }}
            />

            {!hasSearched ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "64px 0",
                  color: "#888",
                  fontSize: "14px",
                }}
              >
                <SearchIcon style={{ fontSize: 50, marginBottom: 20 }} />
                <span>Search for an Embedded step</span>
              </div>
            ) : (
              <>
                <EmbeddedTable
                  onAddAll={(selectedIds) => {
                    selectedIds.forEach((embedId) =>
                      handleClick(id, stepType, studyId, embedId, {
                        closeAfter: false,
                      })
                    );
                    onDone?.();
                  }}
                  loading={loading}
                  data={data}
                />

                <div
                  style={{
                    position: "sticky",
                    bottom: 0,
                    zIndex: 2,
                    background: "#fff",
                    padding: "8px 0",
                    borderTop: "1px solid rgba(0,0,0,0.08)",
                  }}
                >
                  <PaginationBlock
                    resultCount={resultCount}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    onPageChange={onPageChange}
                    onRowsPerPageChange={onRowsPerPageChange}
                  />
                </div>
              </>
            )}
          </>
        ) : (
          <External
            title="Add embedded step"
            addEmbeddedStep={() => handleClick(id, stepType, studyId)}
            toggleItem={toggleItem}
            showParamInput={true}
            value={url}
            onChange={onChange}
            onParamChange={onParamChange}
            onNameChange={onNameChange}
          />
        )}
      </Paper>
    </div>
  );
};

export default StepTypeEmbedded;